export const LIGHT_PARAGRAPH_STYLE =
    " text-sm md:text-base font-normal  font-Montserrat text-black font-light	  ";
